import React, {Component} from "react";
import database from "./database";
import ListGroup from "reactstrap/es/ListGroup";
import ListGroupItem from "reactstrap/es/ListGroupItem";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import "./retail.css";
import Modal from "reactstrap/es/Modal";
import ModalHeader from "reactstrap/es/ModalHeader";
import ModalBody from "reactstrap/es/ModalBody";
import Button from "reactstrap/es/Button";
import Input from "reactstrap/es/Input";
import InputGroupText from "reactstrap/es/InputGroupText";
import Alert from "reactstrap/es/Alert";
import rest from "./restService";
import Spinner from "reactstrap/es/Spinner";
import db from "./database";
import {BiAbacus, BiEditAlt, BiBasket} from "react-icons/bi";

class ListGoods extends Component {

    constructor(props) {
        super(props);
        this.state = {
            goodsCheck: [],
            isOpen: false,
            isOpenMenu: false,
            isOpenSum: false,
            item: {},
            alertColor: 'info',
            alertVisible: false,
            alertText: 'info',
            checkPrice: false,
            menuQty: false,
            spinnerClass: 'off',
            percentLoaded: 0,
            isLoad: false,
            qtyFirst: false,
            isOpenPrice: false,
            debug: false,
            debugtext: '',
        };

        this.db = new database();
        this.rest = new rest();
        this.menuQty = false;
        this.newName();
        this.checks = [];
        if (localStorage.getItem('station_id'))
            this.orgName = localStorage.getItem('station_id');

        if (localStorage.getItem('orgName'))
            this.orgName = localStorage.getItem('orgName');
        else
            this.db.getOrgName((data) => {
                this.orgName = JSON.parse(data).name;
                localStorage.setItem('orgName', this.orgName);
                this.station_id = JSON.parse(data).station_id;
                localStorage.setItem('station_id', this.station_id);
            });
    }

    componentDidMount() {
        this.searchInput.focus();
        let tempArray = JSON.parse(localStorage.getItem('currentCheck'));
        if (!tempArray)
            tempArray = [];
        if (tempArray.length > 0)
            this.setState({
                goodsCheck: tempArray
            });
        this.db.loadLocalStorage();
    }

    saveCheck() {
        this.state.goodsCheck.map((item) => {
            item.date = Date.now();
        });


        localStorage.setItem("currentCheck", JSON.stringify(this.state.goodsCheck));
    }

    spinner(show) {
        if (show && this.searchInput) this.searchInput.disabled = true;
        else this.searchInput.disabled = false;

        let cl = show ? 'spinner' : 'spinner off';
        if (show) this.setState({
            spinnerClass: cl
        });
        this.setState({
            isLoad: show
        });
    }

    update() {
        this.spinner(true);
        (new db(() => {
            this.spinner(false);
            this.db.saveLocalStorage();
        }, (percent) => {
            this.setState({
                percentLoaded: percent
            });
        })).loadAll(true);
        try {
            this.qtyInput.focus();
        } catch (e) {

        }
    }

    newName() {
        this.rest.getNewName((f) => {
            this.docName = f;
        }, (e) => {
            this.docName = 'товары.csv'
        });

    }

    clearSelected() {
        let tempArray = this.state.goodsCheck;
        for (let i = 0; i < tempArray.length; i++) {
            tempArray[i].default = false;
        }
    }

    submit(e) {
        if (e.key === 'Enter') {
            this.db.newSearch(e.target.value, (res) => {
                    let newItem = {};
                    this.clearSelected();
                    let found = false;
                    if (typeof res === 'object') {
                        if (this.state.goodsCheck)
                            this.state.goodsCheck.map((item) => {
                                if (item.barcode === res.barcode) {
                                    this.clearSelected();
                                    newItem = item;
                                    newItem.default = true;
                                    newItem.qty++;
                                    found = true;
                                }
                            });
                        if (!found) {
                            let newItem = res;
                            newItem.default = true;
                            newItem.price_out = newItem.price_out;
                            this.state.goodsCheck.unshift(newItem);
                        }
                        this.setState(this.state);
                    } else {
                        return
                    }
                }
            );
            e.target.value = '';
            this.saveCheck();
        }
    }

    listClicked(e, item) {
        this.clearSelected();
        item.item.default = true;
        this.setState(this.props);
        this.searchInput.focus();
    }

    editClicked(e, item) {
        this.clearSelected();
        item.item.default = true;
        this.setState({
            isOpen: !this.state.isOpen,
            item: item.item,
            qty: parseInt(item.item.qty, 0),
            qtyFirst: true
        });
        if (this.qtyInput)
            this.qtyInput.focus();
    }

    closeModal() {
        this.setState({
            isOpen: !this.state.isOpen
        });
        this.searchInput.focus();
    }

    clickModalOk() {
        let tempItem = this.state.item;
        tempItem = this.state.item;
        tempItem.qty = this.state.qty;
        this.setState({
            isOpen: !this.state.isOpen,
        });
        this.searchInput.focus();
        this.saveCheck();
    }

    clickBtnQty(type) {
        let mQty = type ? this.state.qty + 1 : this.state.qty - 1;
        if (mQty < 0) {
            mQty = 1;
            return;
        }
        this.qtyInput.value = (mQty).toString();
        this.setState({
            qty: mQty
        });
    }

    qtyInputOnChange(e) {
        this.setState({
            qty: e.target.value,
            qtyFirst: false
        });

        if (typeof e.target.value === 'string') {
            let qtyStr = e.target.value;
            this.setState({
                qty: isNaN(parseInt(qtyStr)) ? 0 : parseInt(qtyStr)
            });
        }
    }

    toggleMenu() {
        this.setState({
            isOpenMenu: !this.state.isOpenMenu,
            alertVisible: false
        });
        if (this.searchInput)
            this.searchInput.focus();
    }

    clickNumber(e, num) {
        let qtyText = this.state.qty.toString();
        if (this.state.qtyFirst) {
            this.setState({qtyFirst: false});
            qtyText = '';
        }
        if (num === '#') {
            if (qtyText.length > 1)
                qtyText = qtyText.substring(0, qtyText.length - 1)
            else if (qtyText.length === 1)
                qtyText = '';
        } else {
            qtyText += num;
        }
        let qtyInt = (qtyText === '') ? 0 : parseInt(qtyText, 0);
        this.qtyInput.value = qtyInt;
        this.setState({
            qty: qtyInt
        });
    }

    qtyKeyDown(e) {
        if (this.state.qtyInput) {
            this.setState({qtyFirst: false});
        }
        if (e.key === 'Enter') {
            this.clickModalOk();
        }
    }

    menuChange(type, e) {
        if (type === 'qty')
            this.setState({
                menuQty: e.target.checked
            })
    }

    alertDismiss() {
        this.setState({
            alertVisible: false
        });
    }

    showAlert(color, text) {
        this.setState({
            alertColor: color,
            alertText: text,
            alertVisible: true
        })
    }

    saveDoc() {
        let doc = [];
        this.state.goodsCheck.map((item) => {
            doc.unshift(item);
        });
        this.rest.saveDoc(doc, this.docName, (res) => {
            this.showAlert('success', 'Успішно збережено.');
            this.setState({
                goodsCheck: []
            });
            this.saveCheck();
            this.newName();
        }, (e) => {
            this.showAlert('danger', 'Помилка збереження!');
        });
    }

    qtyModalOpened() {
        this.qtyInput.focus();
        this.qtyInput.select();

    }

    deleteLine(Line) {
        this.clearSelected();
        let i = this.state.goodsCheck.indexOf(this.state.item);
        this.state.goodsCheck.splice(i, 1);
        this.setState({
            isOpen: !this.state.isOpen,
        });
        this.searchInput.focus();
        this.saveCheck();
    }

    getSum() {
        let sum = 0;
        this.state.goodsCheck.map((item) => {
            sum += item.qty * item.price_out;
        });
        return sum;
    }

    doSaling() {
        if (this.state.goodsCheck.length === 0) {
            return
        }
        this.setState({
            isOpenPrice: true
        })
    }

    CloseCheck(check) {
        this.tempChecks = [];
        if (check) {
            this.tempChecks = JSON.parse(localStorage.getItem('allChecks'));
            if (!this.tempChecks)
                this.tempChecks = [];
            this.tempChecks.unshift({
                date: Date.now(),
                org: this.orgName,
                check: this.state.goodsCheck
            });
            localStorage.setItem('allChecks', JSON.stringify(this.tempChecks));
            this.state.goodsCheck = [];
            this.saveCheck();
        }


        this.setState({
            isOpenPrice: false
        });
    }

    render() {

        if (this.state.debug)
            console.log = (message) => {
                if (typeof message == 'object') {
                    this.setState({
                        debugtext: (JSON && JSON.stringify ? JSON.stringify(message) : message) + this.state.debugtext + "\n",
                    })
                } else {
                    this.state.debugtext += message;
                    this.setState({
                        debugtext: this.state.debugtext + "\n"
                    });
                }
            };

        return (
            <div className="body">
                <Spinner color="primary"
                         className="off"/>
                <div className="fixed-top bg-secondary p-3 d-flex justify-content-between align-items-center">
                    <input
                        className="form-control"
                        ref={(input) => {
                            this.searchInput = input;
                        }} onKeyDown={(e) => this.submit(e)}/>
                    <button className="form-control col-3" onClick={() => this.toggleMenu()}><BiAbacus/></button>
                </div>
                <ListGroup className="list-group list-goods">
                    {this.state.goodsCheck.map((item, index) => {
                        return <ListGroupItem action
                                              active={item.default}
                                              id={index}
                                              key={index}
                                              onClick={(e) => {
                                                  this.listClicked(e, {item})
                                              }}
                        >
                            <Row id={index} className="goods-row">
                                <Col className="colName" xs="10">
                                    {item.short_name}<br/>
                                </Col>
                                <Col className="colButton" onClick={(e) => this.editClicked(e, {item})}>
                                    <BiEditAlt/>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="2">
                                    {item.qty}
                                </Col>
                                <Col xs="2">
                                    x
                                </Col>
                                <Col xs="2">
                                    {item.price_out}
                                </Col>
                                <Col xs="4">
                                    = {(item.price_out * item.qty).toFixed(2)}
                                </Col>

                            </Row>
                        </ListGroupItem>
                    })}
                </ListGroup>
                <Modal isOpen={this.state.isOpen} onOpened={() => this.qtyModalOpened()}>
                    <ModalBody>
                        <div className="row item-row">
                            <div className="col-8 item-text">{this.state.item.short_name}</div>
                            <div className="col-4 item-price">{this.state.item.price_out}</div>
                        </div>
                        <div className="row counter">
                            <div className="col-3 counter-cols">
                                <Button outline color="success" className="i-button" onClick={() => {
                                    this.clickBtnQty(false)
                                }}>&nbsp;-&nbsp;</Button>
                            </div>
                            <div className="col-4 counter-cols">

                                <input
                                    ref={(input) => {
                                        this.qtyInput = input;
                                        if (input)
                                            input.focus();
                                    }}
                                    className="form-control qty-input"
                                    defaultValue={this.state.qty}
                                    onChange={(e) => this.qtyInputOnChange(e)}
                                    onKeyDown={(e) => this.qtyKeyDown(e)}
                                />
                            </div>
                            <div className="col-3 counter-cols">
                                <Button outline color="success" className="i-button" onClick={() => {
                                    this.clickBtnQty(true)
                                }}>+</Button>
                            </div>
                        </div>

                        <div className="keypad">
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '1')}>1</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '2')}>2</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '3')}>3</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '4')}>4</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '5')}>5</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '6')}>6</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '7')}>7</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '8')}>8</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '9')}>9</Button>
                            </div>
                            <div className="row">
                                <Button outline color="success" className="i-button invisible-button">0</Button>
                                <Button outline color="success" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '0')}>0</Button>
                                <Button outline color="secondary" className="i-button"
                                        onClick={(e) => this.clickNumber(e, '#')}>{'<'}</Button>
                            </div>
                        </div>
                        <div className="row">
                            <Button color="success" onClick={() => this.clickModalOk()}>Ok</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button color="primary" onClick={() => this.closeModal()}>Відмінитти</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button color="danger" onClick={() => this.deleteLine(this.state.item)}>Видалити</Button>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isOpenMenu}>
                    <ModalHeader toggle={() => this.toggleMenu()}>Меню</ModalHeader>
                    <ModalBody>
                        <br/>
                        <Alert className="alert"
                               color={this.state.alertColor}
                               isOpen={this.state.alertVisible}
                               toggle={() => this.alertDismiss()}>
                            {this.state.alertText}
                        </Alert>
                        <div className="row">
                            <div className="col">
                                <Button color="primary" onClick={() => {
                                    this.toggleMenu();
                                    this.update();
                                }}>Оновити</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isLoad}>
                    <ModalBody>
                        <p>Завантаження бази ...</p>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isOpenPrice}>
                    <ModalBody>
                        <p>Ви дійсно бажаєте закритти чек на суму {this.getSum().toFixed(2)} грн.?</p>
                        <Button color="success" onClick={() => this.CloseCheck(true)}>Так</Button>
                        &nbsp;&nbsp;
                        <Button color="danger" onClick={() => this.CloseCheck(false)}>Ні</Button>
                    </ModalBody>
                </Modal>
                <div className="bottom-line">
                    <Row>
                        <Col xs="2">
                        </Col>
                        <Col xs="3">
                            Сума
                        </Col>
                        <Col xs="4">
                            {this.getSum().toFixed(2)}
                        </Col>
                        <Col xs="1">
                            <Button onClick={() => this.doSaling()}>
                                <BiBasket/>
                            </Button>
                        </Col>
                    </Row>
                </div>
                <div>
                    {this.state.debug ? this.state.debugtext : null}
                </div>
            </div>
        )
    }
}

export default function () {
    return (
        <ListGoods></ListGoods>

    )
}
